"use strict";

const audio = document.getElementById("ambientAudio");
const audioButtons = document.querySelectorAll(".audio-toggle");
const audioIcon = document.querySelector(".audio-floating__icon");

if (audio && audioButtons.length > 0) {
  function updateAudioButtons(isPlaying) {
    audioButtons.forEach((button) => {
      button.classList.toggle("is-active", isPlaying);
      button.setAttribute(
        "aria-label",
        isPlaying ? "Couper l’ambiance sonore" : "Activer l’ambiance sonore"
      );
    });

    if (audioIcon) {
      audioIcon.src = isPlaying
        ? "./assets/img/music.svg"
        : "./assets/img/no-music.svg";
    }

    const heroButton = document.querySelector(".hero__audio-button");

    if (heroButton) {
      heroButton.textContent = isPlaying
        ? "Couper l’ambiance sonore"
        : "Lancer l’ambiance sonore";
    }
  }

  audioButtons.forEach((button) => {
    button.addEventListener("click", () => {
      if (audio.paused) {
        audio.play();
        localStorage.setItem("aphro-audio-enabled", "true");
        updateAudioButtons(true);
      } else {
        audio.pause();
        localStorage.setItem("aphro-audio-enabled", "false");
        updateAudioButtons(false);
      }
    });
  });
}